export default class TarteAuCitron extends HTMLElement {

    constructor() {
        super();
    }

    connectedCallback() {
        $("#tarteaucitronO").on("click", function(e){
            e.preventDefault();
            tarteaucitron.userInterface.openPanel();
        });
    }

}